/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://coffeescript.org/

class ExplodedViewDiagram {
  constructor(element_id, finderMode) {
    this.element_id = element_id;
    const target = $(this.element_id);
    let src = target.data("src");

    if (src) {
      // In IE8 and 9, page and ajax resource must use the same protocol
      // If one uses http and the other https, a "No transport" error will occur.
      if ('https:' !== document.location.protocol) {
        src = src.replace('https:', 'http:');
      }

      const ajaxConfig = {
        url: src,
        type: "GET",
        dataType: "text",
        cache: false,
        headers: {
         'Cache-Control': 'private, max-age=0'
       } 
      };

      const successFunction = data => {
        target.html(data);
        if (finderMode === "fullscreen") {
          this.bindPopovers();
        } else {
          this.bindTooltips();
        }

        this.bindPanZoom(this.element_id);
        this.bindZoomControls(this.element_id);
        return this.setContainerSize(this.element_id);
      };

      $.ajax(ajaxConfig)
        .success(successFunction);
    }
  }

  setContainerSize(element_id) {
    const width = $(element_id).parent().width();
    return $(element_id).parent().css("width", width);
  }
    
  bindPanZoom(element_id) { 
      const config = { 
        events: {
          mouseWheel: false,
          doubleClick: false
        }
      };
          
      return this.viewfinder = $(element_id + " svg").svgPanZoom(config);
    }
  
  bindZoomControls(element_id) {
    $(".controls .zoomOut").on("click", () => {
      return this.viewfinder.zoomOut();
    });
    return $(".controls .zoomIn").on("click", () => {
      return this.viewfinder.zoomIn();
    });
  }
      
  
  bindPopovers() {
    const config = {
      container: "body",
      placement: "top",
      template: '<div class="popover" role="tooltip" style="max-width: 475px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      html: true,
      trigger: "hover focus click",
      delay: {
        show: 0,
        hide: 1000
      },
      content() {
        const elementId = $(this).attr("id");
        const targetId = elementId.match(/repere[_]?(\d+)/).pop();
        return $("[data-marker-id="+targetId+"]").html();
      }
    };

    const tipped_elements = $("g#reperes g[id*=repere]");
    return tipped_elements.popover(config);
  }
  
  bindTooltips() {
    // Tooltip title comes from the svg rect element
    const config = {
      container: "body",
      placement: "top",
      title: function() {
        const elementId = $(this).attr("id");
        const targetId = elementId.match(/repere[_]?(\d+)/).pop();
        const title = $("[data-marker-id="+targetId+"]").data("callout-title");
        return title;
      }
    };

    const tipped_elements = $("g#reperes g[id*=repere]");
    tipped_elements.tooltip(config);

    tipped_elements.on("show.bs.tooltip", function() {
      const elementId = $(this).attr("id");
      const targetId = elementId.match(/repere[_]?(\d+)/).pop();
      return $("[data-marker-id="+targetId+"]").addClass("highlighted");
    });

    tipped_elements.on("hidden.bs.tooltip", function() {
      const elementId = $(this).attr("id");
      const targetId = elementId.match(/repere[_]?(\d+)/).pop();
      return $("[data-marker-id="+targetId+"]").removeClass("highlighted");
    });

    $(".callout-list-item").on("mouseenter", function(event) {
      const id = $(this).data("marker-id");
      return $("g#repere"+id+", g[id*=repere"+id+"_]").tooltip("show");
    });

    return $(".callout-list-item").on("mouseleave", function(event) {
      const id = $(this).data("marker-id");
      return $("g#repere"+id+", g[id*=repere"+id+"_]").tooltip("hide");
    });
  }
}


$(document).ready(function() {
  if ($("#exploded_view_diagram_wrapper").length > 0) {
    const finderMode = $("#exploded_view_diagram_wrapper").data("finder-mode");
    
    const viewfinder = new ExplodedViewDiagram("#exploded_view_diagram_wrapper", finderMode);
  }
    
  if ($(".exploded_view_diagram_belts").length > 0) {
    const config = { 
      offset: {
        top: 421
      }
    };
      
    $(".exploded_view_diagram_belts[data-affix]").affix(config)
      .on('affix.bs.affix', () => $('#callouts_table').addClass("padded")).on('affix-top.bs.affix', () => $('#callouts_table').removeClass("padded"));
  }
      
  if ($("#callout_list").length > 0) {
    return $("a.add-ref-link").on("click", function(event) {
      const template = jQuery.parseJSON($(this).data("template")).replace(/index_to_replace_with_js/g, new Date().getTime());
      
      const target = $(this).data("target-element");
      const cell = $($(this).data("position-cell-id"));
      const rowspan = parseInt(cell.attr("rowspan"), 10);
      cell.attr("rowspan", rowspan+1);

      $(target+":last").after(template);

      return false;
    });
  }
});
      